import * as constants from './constants';
import { audioOutputSlice } from './slice';

export default { constants, audioOutputSlice };
